import React, { useState, useEffect } from "react";
import { css } from "emotion";

import Container from "components/shared/Container";

import { getProducts, IProduct } from "api/heroku";
import Spinner from "components/shared/Spinner";
import Product from "components/home/Product";

import styleConfig from "styles/styleConfig";
const { colors, padding } = styleConfig;

const productsWrapper = css`
  .content {
    padding: ${padding[4]};
    min-height: 50vh;
    .products {
      display: flex;
      flex-flow: row wrap;
    }
  }
`;

interface Props {}

const Products: React.FC<Props> = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<IProduct[]>([]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const response = await getProducts();
      console.log({ response });
      setProducts(response);
      setLoading(false);
    }
    fetchData();
  }, []);

  const renderProducts = products.map(product => (
    <Product
      key={product.id}
      image={product.image}
      price={product.price}
      title={product.name}
      oldPrice={product.oldPrice}
      unit={product.unit}
    />
  ));

  return (
    <div className={productsWrapper}>
      <Container className="container">
        <div className="content">
          <p
            className={css`
              padding: 1rem;
              margin-bottom: 2rem;
              border-radius: 0.5rem;
              background-color: ${colors.secondary[200]};
              color: ${colors.secondary[600]};
            `}
          >
            In de toekomst zullen er meer producten toegevoegd worden.
          </p>
          {products.length ? <div className="products">{renderProducts}</div> : loading && <Spinner />}
        </div>
      </Container>
    </div>
  );
};

export default Products;
